var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoSm = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9D9FA2",
    d: "M14.327 3.096c-.158-.19-.348-.348-.507-.507A7.66 7.66 0 0 0 8.656.593 7.654 7.654 0 0 0 .988 8.261c0 1.996.76 3.802 1.996 5.165.158.19.349.348.507.506a7.66 7.66 0 0 0 5.165 1.997 7.654 7.654 0 0 0 7.667-7.668c0-1.996-.728-3.802-1.996-5.165M8.656 15.232a7.02 7.02 0 0 1-4.69-1.806l-.475-.476a7.02 7.02 0 0 1-1.806-4.69c0-3.833 3.137-6.97 6.97-6.97 1.807 0 3.454.697 4.69 1.806l.475.475a7.02 7.02 0 0 1 1.806 4.69 6.95 6.95 0 0 1-6.97 6.97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0668B3",
    d: "M8.655 14.028a5.767 5.767 0 1 0 0-11.534 5.767 5.767 0 0 0 0 11.534"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.395 6.993c-.254-.253-.824-.412-1.521-.412-.349 0-.666.032-.92.127v2.345c.033 0 .064-.032.096-.032.253-.063.539-.095.824-.095.317 0 .602.032.824.095.316.064.57.19.697.349v2.281c-.254-.253-.824-.412-1.521-.412-.349 0-.666.032-.92.127V9.085l-2.597.823v2.282c-.032 0-.064.031-.095.031a3.5 3.5 0 0 1-.824.095c-.317 0-.57-.031-.824-.095-.317-.063-.57-.19-.697-.348V9.592c.253.253.824.412 1.52.412.35 0 .666-.032.92-.127V7.532c-.032 0-.064 0-.095.032a3.5 3.5 0 0 1-.824.095 3.3 3.3 0 0 1-.824-.095c-.317-.064-.57-.19-.697-.317V4.966c.253.253.824.411 1.52.411.35 0 .666-.031.92-.126v2.281l2.598-.855V4.395c.032 0 .063-.032.095-.032.253-.063.539-.095.824-.095.317 0 .602.032.824.095.316.064.57.19.697.349z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoSm);
export default ForwardRef;